module.exports = __webpack_public_path__ + "static/afolayan-4a70083df1fd29f70a71ac70e9b77318.png";